/* unplugin-vue-components disabled */import script from "./flows.vue?vue&type=script&setup=true&lang=js"
export * from "./flows.vue?vue&type=script&setup=true&lang=js"

import "./flows.vue?vue&type=style&index=0&id=1e6115fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6115fa"]])

export default __exports__